import {
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerProps,
  FormControl,
  FormLabel,
  Stack,
} from '@chakra-ui/react';
import { PutRoleRequest } from 'api/bindings/PutRoleRequest';
import { RoleResponse } from 'api/bindings/RoleResponse';
import { AppInput, FormButtonGroup } from 'features/components';
import { FormProvider, useForm } from 'react-hook-form';

export interface EditClientRoleFormDrawerProps
  extends Omit<DrawerProps, 'onSubmit' | 'children'> {
  role: RoleResponse;
  onSubmit: (role: PutRoleRequest) => void;
  onClose: () => void;
}

interface Form extends PutRoleRequest {}

export const EditClientRoleFormDrawer = (props: EditClientRoleFormDrawerProps) => {
  let { role, onSubmit, onClose, ...rest } = props;

  // State
  const form = useForm<Form>({
    mode: 'all',
    defaultValues: {
      id: role.id,
      name: role.name,
      defaultAfeApprovalAuthority: role.defaultAfeApprovalAuthority,
      defaultPurchaseOrderApprovalAuthority: role.defaultPurchaseOrderApprovalAuthority,
      defaultWorkOrderApprovalAuthority: role.defaultWorkOrderApprovalAuthority,
      defaultInvoiceApprovalAuthority: role.defaultInvoiceApprovalAuthority,
    },
  });
  const { register, watch, handleSubmit } = form;
  const formName = watch('name');

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DrawerContent {...rest}>
          <DrawerCloseButton />
          <DrawerHeader>Edit Role: {formName}</DrawerHeader>
          <DrawerBody>
            <Stack spacing={4}>
              <FormControl>
                <FormLabel htmlFor="name">Name:</FormLabel>
                <AppInput
                  id="name"
                  {...register('name', {
                    required: 'Name is required',
                    minLength: 3,
                    maxLength: 256,
                  })}
                />
              </FormControl>
            </Stack>
            <Stack spacing={4}>
              <FormControl>
                <FormLabel htmlFor="defaultAfeAuthority">
                  AFE Authority:
                </FormLabel>
                <AppInput
                  id="defaultAfeAuthority"
                  type="currency"
                  {...register('defaultAfeApprovalAuthority')}
                />
              </FormControl>
              <FormControl>
                <FormLabel htmlFor="defaultPoAuthority">
                  Purchase Order Authority:
                </FormLabel>
                <AppInput
                  id="defaultPoAuthority"
                  type="currency"
                  {...register('defaultPurchaseOrderApprovalAuthority')}
                />
              </FormControl>
              <FormControl>
                <FormLabel htmlFor="defaultWoAuthority">
                  Work Order Authority:
                </FormLabel>
                <AppInput
                  id="defaultWoAuthority"
                  type="currency"
                  {...register('defaultWorkOrderApprovalAuthority')}
                />
              </FormControl>
              <FormControl>
                <FormLabel htmlFor="defaultInvAuthority">
                  Invoice Authority:
                </FormLabel>
                <AppInput
                  id="defaultInvAuthority"
                  type="currency"
                  {...register('defaultInvoiceApprovalAuthority')}
                />
              </FormControl>
            </Stack>
          </DrawerBody>
          <DrawerFooter>
            <FormButtonGroup
              onCancel={onClose}
              onConfirm={handleSubmit(onSubmit)}
            />
          </DrawerFooter>
        </DrawerContent>
      </form>
    </FormProvider>
  );
};